// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 383 ? "71365615" : chunkId) + "." + {"383":"4958dee91b9f8fd6","444":"769772c89704e437","457":"740ca4168c951d4c"}[chunkId] + ".js";
};